import { ClientFetchService } from "@lib/helpers/clientFetchService";
import type { QueryClient } from "@tanstack/react-query";

const invalidPostalCodesKeyFactory = ({ country }: { country: string }) => [
    "invalidPostalCodes",
    country?.trim()?.toLowerCase(),
];

const fetchInvalidPostalCodesForCountry = async (country: string): Promise<string[]> => {
    if (!country?.trim()) return [];

    const normalizedCountry = country.toLowerCase().trim();

    try {
        const data = await ClientFetchService.get<string[]>(
            `/api/country/${normalizedCountry}/invalid-postal-codes`
        );
        return data ?? [];
    } catch {
        return [];
    }
};

export const prefetchInvalidPostalCodesForCountry = (country: string, queryClient: QueryClient) => {
    const fetcher = () => fetchInvalidPostalCodesForCountry(country);
    const key = invalidPostalCodesKeyFactory({ country });
    return queryClient.prefetchQuery({
        queryKey: key,
        queryFn: fetcher,
        staleTime: Infinity,
    });
};

export const getInvalidPostalCodesForCountry = (country: string, queryClient: QueryClient) => {
    const fetcher = () => fetchInvalidPostalCodesForCountry(country);
    const key = invalidPostalCodesKeyFactory({ country });
    return queryClient.ensureQueryData({
        queryKey: key,
        queryFn: fetcher,
        staleTime: Infinity,
    });
};
